export default {
  'zh': {
    'retry': '重试',
    'failed': '敏感信息获取失败，请重试。',
    'refresh': '数据已过期，请重新查询后再查看。',
    'forbidden': '没有查看敏感信息的权限。',
    'invalid': '敏感数据格式无效，请重新查询。',
    'limit': '本次敏感字段过多或过长，请缩小查询范围。',
    'show': '查看敏感信息',
    'hide': '隐藏敏感信息'
  },
  'en': {
    'retry': 'Retry',
    'failed': 'Unable to retrieve sensitive information. Please retry.',
    'refresh': 'This data is outdated. Refresh the query before viewing.',
    'forbidden': 'You do not have permission to view sensitive information.',
    'invalid': 'Invalid sensitive data. Please refresh the query.',
    'limit': 'Too many or oversized sensitive fields. Narrow the query.',
    'show': 'Show sensitive information',
    'hide': 'Hide sensitive information'
  },
  'ptBr': {
    'retry': 'Tentar novamente',
    'failed': 'Não foi possível consultar os dados sensíveis. Tente novamente.',
    'refresh': 'Os dados estão desatualizados. Consulte novamente antes de visualizar.',
    'forbidden': 'Você não tem permissão para visualizar dados sensíveis.',
    'invalid': 'Dados sensíveis inválidos. Consulte novamente.',
    'limit': 'Há campos sensíveis demais ou muito longos. Reduza a consulta.',
    'show': 'Mostrar dados sensíveis',
    'hide': 'Ocultar dados sensíveis'
  }
};
